import { Tag } from "antd";

export const RFQStatus = {
  DRAFT: "draft",
  PENDING_APPROVAL: "pending_approval",
  PUBLISHED: "published",
  QUOTATION_RECEIVED: "quotation_received",
  ORDER_PLACED: "order_placed",
  ORDER_CONFIRMED: "order_confirmed",
  QUOTATION_SENT: "quotation_sent",
  REJECTED: "rejected",
  APPROVED: "approved",
  NEGOTIATE: "NEGOTIATE",
  BLOCK_THE_RATE: "BLOCK_THE_RATE",
  SUBMITTED: "Submitted",
  CONFIRMED: "Confirmed",
  OFFER_REJECTED: "Rejected",
};

export const EnquiryStatus = {
  QUOTATION_SENT: "quotation_sent",
  QUOTATION_RECEIVED: "quotation_received",
  ORDER_PLACED: "order_placed",
  ORDER_CONFIRMED: "order_confirmed",
  NEW_ENQUIRY: "new_enquiry",
  AWAITING_FOR_QUOTATION: "awaiting_for_quotation",
  PUBLISHED: "published",
  REJECTED: "rejected",
  DRAFT: "draft",
  APPROVED: "approved",
  PENDING_APPROVAL: "pending_approval",
  NEGOTIATE: "NEGOTIATE",
  BLOCK_THE_RATE: "BLOCK_THE_RATE",
  SUBMITTED: "Submitted",
  CONFIRMED: "Confirmed",
  OFFER_REJECTED: "Rejected",
};

export const ExporterPortPairUploadedStatus = {
  UPLOADED: "Uploaded",
  FAILED: "Failed",
  PROCESSING: "Processing",
};

export const BUSINESS_TYPE = {
  EXPORTER: "exporter",
  BUYER: "buyer",
  MANUFACTURER: "manufacturer",
  COMMISSION_AGENT: "commission_agent",
  CUSTOM_HOUSE_AGENT: "custom_house_agent",
  FREIGHT_FORWARDER: "freight_forwarder",
  SHIPPING_LINE: "shipping_line",
  MANUFACTURER_EXPORTER: "manufacturer_exporter",
  CUSTOMHOUSEAGENTS_FREIGHTFORWARDER: "customhouseagents_freightforwarder",
  ADMIN:"admin"
};

export const BUSINESS_TYPE_FOR_MESSAGE = {
  exporter: "Exporter",
  buyer: "Buyer",
  manufacturer: "Manufacturer",
  commission_agent: "Commission Agent",
  custom_house_agent: "Custom House Agent (CHA)",
  freight_forwarder: "Freight Forwarder",
  shipping_line: "Shipping Line",
  manufacturer_exporter: "Manufacturer Cum Exporter",
  customhouseagents_freightforwarder:
    "Custom House Agents Cum Freight Forwarder",
};
export const BUSINESS_TYPE_LABEL = {
  exporter: "Exporter",
  buyer: "Buyer",
  manufacturer: "Manufacturer",
  commission_agent: "Commission Agent",
  custom_house_agent: "Custom House Agent",
  freight_forwarder: "Freight Forwarder",
  shipping_line: "Shipping Line",
  manufacturer_exporter: "Manufacturer Cum Exporter",
  customhouseagents_freightforwarder: "Custom House Agents Cum Freight Forwarder",
};
export const BUSINESS_TYPE_ID = {
  1: "buyer",
  2: "exporter",
  3: "manufacturer",
  4: "commission_agent",
  5: "custom_house_agent",
  6: "freight_forwarder",
  7: "shipping_line",
  8: "manufacturer_exporter",
  9: "customhouseagents_freightforwarder",
};

export const FORM_BUSINESS_TYPE = {
  buyer: "0",
  exporter: "1",
  manufacturer: "2",
  commission_agent: "3",
  custom_house_agent: "4",
  freight_forwarder: "5",
  shipping_line: "6",
  manufacturer_exporter: "7",
  customhouseagents_freightforwarder: "8",
};

export const FORM_BUSINESS_TYPE_FOR_PORT = {
  exporter: "0",
  manufacturer_exporter: "7",
  freight_forwarder: "2",
  customhouseagents_freightforwarder: "3",
  custom_house_agent: "1",
};

export const APP_TYPE = {
  ADMIN: "admin",
  USER: "user",
};

export const BUSINESS_CARD_STATUS = {
  SENT: "sent",
  ACCEPTED: "accepted",
  REJECTED: "rejected",
};

export const PRODUCT_STATUS = {
  DRAFT: "draft",
  PENDING_APPROVAL: "pending_approval",
  PUBLISHED: "published",
  REJECTED: "rejected",
};

export const USER_STATUS = {
  PENDING_APPROVAL: "pending_approval",
  PENDING: "Pending",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

export const PROMOTION_BANNER_STATUS = {
  PENDING_APPROVAL: "pending_approval",
  APPROVED: "approved",
  REJECTED: "rejected",
};

export const total_quotations = 100;
export const business_card_request = true;

export const CERT_KEY = {
  GST: "GST",
  EXIM: "EXIM",
  COMPANY: "CC",
};
export const LEAD_TITLE = {
  LEADS: "Leads",
  BUYER_LEADS: "Buyer Leads",
  EXPORTER_LEADS: "Exporter Leads",
  CUSTOM_HOUSE_AGENT_LEADS: "Custom House Agents Leads",
  FREIGHT_FORWARDER_LEADS: "Freight forwarders Leads",
};

export const LEAD_DIFFER_DAYS = {
  DAYS: 7,
};

export const RUPEE_PER_POINT = 100;

export const CURRENCY_CODE_INR = "INR";

export const DEFAULT_ENQUIRY_CREDIT_CONFIG = {
  freeFunds: 1000,
  freeEnquiries: 10,
  freePorts: 50,
  freeContainers: 50,
  perEnquiryCharge: 50,
  minAddFundsAmount: 500,
  maxAddFundsAmount: 100000,
  currency: CURRENCY_CODE_INR,
};

export const FREIGHT_ENQUIRY_PRICE_SLABS = [
  { min: 0, max: 5, amount: 50 },
  { min: 6, max: 10, amount: 100 },
  { min: 11, max: 20, amount: 200 },
  { min: 21, max: Number.POSITIVE_INFINITY, amount: 300 },
];

export const CHAT_BUSINESS_TYPE_ID = {
  1: "Buyer",
  2: "Exporter",
  3: "Manufacturer",
  4: "Commission Agent",
  5: "Custom House Agent",
  6: "Freight Forwarder",
  7: "Shipping Line",
  8: "Manufacturer Cum Exporter",
  9: "customhouseagents_freightforwarder",
};

export const OFFER_PRODUCT_BUSINESS_TYPE = {
  exporter: "2",
  manufacturer_exporter: "8",
  buyer: "1",
};

export const RFQ_TYPE = {
  CIF : "CIF",
  NEGOTIATE : "Negotiate",
  RATE_BLOCKED: "Rate Blocked",
}

export const RFQ_STATUS = {
  SUBMITTED : "Submitted",
  CONFIRMED : "Confirmed",
  REJECTED: "Rejected",
}

export const OFFER_CARGO_ALLOWED_EMAIL = {
  EMAIL_ID: "tskexportsandimports@gmail.com"
}

export const BusinessRequestStatus = {
  PENDING: "pending",
  REJECTED: "rejected",
  APPROVED: "approved",
  
};

export const BUSINESS_REQUEST_STATUS = {
  PENDING: "Pending",
  REJECTED: "Rejected",
  APPROVED: "Approved",
}

export const STATUS_BUSINESS_TYPE = {
  CUSTOM_HOUSE_AGENT: 5,
  FREIGHT_FORWARDER: 6,
  CUSTOMHOUSEAGENTS_FREIGHTFORWARDER: 9,
};

export const statusDetails = {
  [BusinessRequestStatus.PENDING]: {
    label: "Pending",
    color: "#F5993F",
  },
  [BusinessRequestStatus.APPROVED]: {
    label: "Approved",
    color: "#2FB07E",
  },
  [BusinessRequestStatus.REJECTED]: {
    label: "Rejected",
    color: "#FF0000",
  },
};

export const BusinessRequestStatusTags = ({ status }) => {
  return (
    <div>
      <Tag color={statusDetails[status]?.color}>
        {statusDetails[status]?.label}
      </Tag>
    </div>
  );
};
